import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Montana = () => {
  return (
    <StatePropertyTaxPage
      stateName="Montana"
      processDescription="Property owners may file appeals with the county tax appeal board within 30 days of receiving their assessment notice. Written appeals should include evidence supporting the property owner's valuation claim."
      noticeOfValueMailed="June"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in June to allow for the appeal process before tax bills are finalized."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Montana assesses property as of January 1 each year. This assessment date ensures consistent property valuations across all counties in Montana for the current tax year."
      deadlineExplanation="Property owners have 30 days from the notice mailing date to file appeals. The exact deadline depends on when notices are mailed but typically falls in July."
    />
  );
};

export default Montana;